var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Top_Highlighted_Arrow",
    "data-name": "Top Highlighted Arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1655",
    "data-name": "Rectangle 1655",
    d: "M0,0H30a2,2,0,0,1,2,2V18a1,1,0,0,1-1,1H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#fefefd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Icon",
    "data-name": "Arrow Icon",
    transform: "translate(21.03 11.515) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M3255.036,2648l5.015,5.015,5.015-5.015",
    transform: "translate(-3255.036 -2648)",
    fill: "none",
    stroke: "#3a3943",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.5036693a33cb50bd97884d582cf33ec8.svg";
export { ForwardRef as ReactComponent };